module.exports = __webpack_public_path__ + "img/p-17.2b41640d.jpg";